"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GuidesInputBar;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _inputBar = _interopRequireDefault(require("@site/pattern-library-core/input-bar"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GuidesInputWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GuidesInputWrapper",
  class: "pl-g2f38e0"
});

/**
 * Render Suggestion
 *
 * @param {Object} props React props
 * @param {String} props.suggestion Suggestion populating dropdown
 * @returns {React.ReactElement} Suggestion option
 * @public
 */
function Suggestion({
  suggestion
}) {
  return /*#__PURE__*/_react.default.createElement("option", null, suggestion);
}
Suggestion.propTypes = {
  suggestion: _propTypes.default.string
};

/**
 * Render Dropdown
 *
 * @param {Object} props React props
 * @param {Array} props.autoSuggest Array of Suggestions provided by help api
 * @returns {React.ReactElement} Autosuggest Dropdown
 * @public
 */
function Dropdown({
  autoSuggest
}) {
  return /*#__PURE__*/_react.default.createElement("datalist", {
    id: "guidesDropdown"
  }, autoSuggest?.map((suggestion, i) => /*#__PURE__*/_react.default.createElement(Suggestion, {
    key: i,
    suggestion: suggestion
  })));
}
Dropdown.propTypes = {
  autoSuggest: _propTypes.default.arrayOf(_propTypes.default.string)
};

/**
 * Debounce function
 * Executes the function and returns the value.
 * In this case the function returns void
 *
 * @param {Function} func Function to debounce
 * @param {Number} timeout Amount of time to delay function execution
 * @returns {void} Nothing is returned
 * @public
 */
function debounce(func, timeout) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

/**
 * Render GuidesInputBar
 *
 * @param {Object} props React props
 * @param {Object} props.searchForm Search form
 * @returns {React.ReactElement} GuidesInputBar
 * @public
 */
function GuidesInputBar({
  searchForm
}) {
  const [query, setQuery] = (0, _react.useState)('');
  const [autoSuggest, setAutoSuggest] = (0, _react.useState)('');
  const handleChange = value => {
    setQuery(value);
  };
  const debouncedHandleChange = (0, _react.useCallback)(debounce(handleChange, 200), []);
  searchForm.handleChange = debouncedHandleChange;
  (0, _react.useEffect)(() => {
    if (query || autoSuggest) {
      fetch(searchForm.helpSuggestApi + '?q=' + query).then(r => r.json()).then(data => setAutoSuggest(data.terms));
    }
  }, [query]);
  return /*#__PURE__*/_react.default.createElement(GuidesInputWrapper, null, /*#__PURE__*/_react.default.createElement(_inputBar.default, (0, _extends2.default)({
    list: "guidesDropdown"
  }, searchForm)), autoSuggest && /*#__PURE__*/_react.default.createElement(Dropdown, {
    autoSuggest: autoSuggest
  }));
}
GuidesInputBar.propTypes = {
  searchForm: _propTypes.default.shape({
    inputFieldName: _propTypes.default.string,
    id: _propTypes.default.string,
    searchButtonText: _propTypes.default.string,
    button: _propTypes.default.object,
    helpUrl: _propTypes.default.string,
    helpSuggestApi: _propTypes.default.string,
    handleChange: _propTypes.default.func,
    ..._inputBar.default.propTypes
  })
};